import { Directive } from "vue"

const directive: Directive = {
    mounted(el, binding) {
        el.clickOutsideEvent = function (event: Event) {
            if (el === event.target) {
                if (typeof binding.value === 'function') {
                    binding.value(event);
                }
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
};

export default directive;